"use client";

import {ManageBookingItem} from "@/types/booking";
import {AiOutlineFileSearch} from "react-icons/ai";
import {Card} from "./card";

const completedDummyCards: ManageBookingItem[] = [
  {
    name: "Demo User 1",
    image: "/images/avatar.png",
    bookingId: 3001,
    vehicleName: "TN09Z4455",
    bookingTime: new Date("2026-05-27T08:30:00").getTime(),
    driverName: "Vignesh Driver",
    driverEmpId: "SAMP071",
    pickupPoint: "Saibaba Colony",
    dropPoint: "NeoSay Campus"
  },
  {
    name: "Demo User 2",
    image: "/images/avatar.png",
    bookingId: 3002,
    vehicleName: "TN66BY2295",
    bookingTime: new Date("2026-05-27T18:00:00").getTime(),
    driverName: "Kumar Driver",
    driverEmpId: "SAMP072",
    pickupPoint: "Town Hall",
    dropPoint: "Saravanampatti"
  }
];

export const Completed = ({
  filterData
}: {
  filterData: ManageBookingItem[] | null;
}) => {
  const cardsToRender =
    filterData && filterData.length > 0 ? filterData : completedDummyCards;

  return (
    <>
      <div className="grid grid-cols-4 gap-3 p-3">
        {cardsToRender.map((b: ManageBookingItem) => (
          <Card key={b.bookingId} b={b} statusType={3} />
        ))}
        {!filterData && (
          <div className="col-span-full flex min-h-[260px] w-full flex-col items-center justify-center text-center">
            {/* Icon */}
            <div className="mb-4">
              <AiOutlineFileSearch size={48} className="" />
            </div>

            {/* Title */}
            <h2 className="text-lg font-semibold text-gray-800">
              No record found
            </h2>

            {/* Description */}
            <p className="mt-1 text-sm text-gray-500">
              Please adjust the name of your search, or there is no data
              available.
            </p>
          </div>
        )}
      </div>
    </>
  );
};
